import * as React from "react";

import { IEventViewProps } from "../EventView";

import { IDayCell_MonthMobile, IDayCellSlot_MonthMobile } from "../../../classes/dayCell_MonthMobile";
import { IText } from "../../../classes/Text";

import { WeeklyListDay } from "./WeeklyListDay";

import * as dates from "../../../reducers/changeTimePeriod";

import * as utils from "../Common/ListViewUtils";

const getDayListItemsForMonth = (theDayCells: IDayCell_MonthMobile[], props: IEventViewProps) => {
    const dayListItems: JSX.Element[] = [];

    for (const dayCell of theDayCells) {
        dayListItems.push(
            <WeeklyListDay
                key={dayCell.cellNumber}
                dayCell={dayCell}
                currentDate={props.currentDate}
                selectedDate={props.selectedDate}
                todaysDate={props.todaysDate}
                text={props.text}
                contextId={props.contextId}
                pageId={props.pageId}
                parentId={props.parentId}
                portalId={props.portalId}
                portletInstanceId={props.portletInstanceId}
                userDateFormat={props.userDateFormat}
                viewMode={props.viewMode}
                onStartAjaxCall={props.onStartAjaxCall}
                onSetEventId={props.onSetEventId}
                onSetEventScreenMode={props.onSetEventScreenMode}
                onSetiCalStartDate={props.onSetiCalStartDate}
                onSetDisplayedEventLocalStartDate={props.onSetDisplayedEventLocalStartDate}
                onSetDisplayedEventLocalEndDate={props.onSetDisplayedEventLocalEndDate}
                onSetCurrentDate={props.onSetCurrentDate}
                onSetSelectedDate={props.onSetSelectedDate}
                onSetViewMode={props.onSetViewMode}
            />);
    }

    return dayListItems;
};

export const WeeklyListDays = (props: IEventViewProps) => {

    // Convert list of events into array of day cells for days of the month, each with event slots.
    const dayCells: IDayCell_MonthMobile[] = utils.transformListOfEventsIntoArrayOfDayCellsForMonth_Mobile(props);

    // Generate JSX list items for the days of the month.
    const days = getDayListItemsForMonth(dayCells, props);

    return (
        <div>
            <ul className="CAL-V-MV-list">
                {days}
            </ul>
        </div>
    );
};
